import React, { FC } from 'react'
import {
  AnotherOperatorClientCard,
  checkIsMtsClient,
  getMtsBinding,
  MtsClientCard,
  useAuthDataStore,
  useBindingsStore,
} from '@entities/user'
import { PaymentTemporarilyUnavailableBanner } from '@entities/payment'

const MtsPaymentMethodContent: FC = () => {
  const { isAuth, operatorMTS, getPhone, paymentBanMTS, errorOperatorInfo } = useAuthDataStore()

  const { bindings } = useBindingsStore()

  const mtsBinding = getMtsBinding(bindings)
  const isMtsClient = checkIsMtsClient(bindings, isAuth, operatorMTS, paymentBanMTS)
  // const mtsBinding = getMtsBinding([binding])
  // const isMtsClient = true
  const isAnotherOperator = isAuth && !!getPhone() && !operatorMTS && !errorOperatorInfo

  if (isMtsClient && mtsBinding?.balance !== undefined) {
    return <MtsClientCard />
  }

  if (isAnotherOperator) {
    return <AnotherOperatorClientCard />
  }

  return <PaymentTemporarilyUnavailableBanner />
}

export default MtsPaymentMethodContent
